import { AxiosResponse } from 'axios'
import { accidentsApi, employeesApi } from '.'

import { Vendor } from '../interfaces/Vendor.interface'

export const getLocations = () => (
  employeesApi.get<Location[]>('/location')
    .then((response: AxiosResponse) => response.data)
)

export const getLocationPositions = (locationId: number) => (
  accidentsApi.get<Position[]>(`/location/${locationId}/position`)
    .then((response: AxiosResponse) => response.data)
)

export const getVendors = () => (
  accidentsApi.get<Vendor[]>('/claim/vendor')
    .then((response: AxiosResponse) => response.data)
)



// WEBPACK FOOTER //
// ./src/lib/api/locations.ts